module.exports = __webpack_public_path__ + "assets/luggage.951ea34c.svg";